window.HHmm = function(d) {
  let HH = d.getHours().toString(),
  mm = d.getMinutes().toString()
  return (HH[1] ? HH : '0' + HH[0]) + ':' + (mm[1] ? mm : '0' + mm[0])
}

window.HHmmss = function(d) {
  var HH = d.getHours().toString(),
  mm = d.getMinutes().toString(),
  ss = d.getSeconds().toString()
  return(HH[1] ? HH : '0' + HH[0]) + ':' + (mm[1] ? mm : '0' + mm[0]) + ':' + (ss[1] ? ss : '0' + ss[0])
}

window.mmdd = function(d) {
  var mm = (d.getMonth() + 1).toString()
  var dd = d.getDate().toString()
  return(mm[1] ? mm : '0' + mm[0]) + '-' + (dd[1] ? dd : '0' + dd[0])
}

window.yyyymmdd = function(d) {
  let yyyy = d.getFullYear().toString()
  let mm = (d.getMonth() + 1).toString()
  let dd = d.getDate().toString()
  return yyyy + '-' + (mm[1] ? mm : '0' + mm[0]) + '-' + (dd[1] ? dd : '0' + dd[0])
}

window.yyyymmddHHmm = function(d) {
  return yyyymmdd(d) + ' ' + HHmm(d)
}

window.yyyymmddHHmmss = function(d) {
  return yyyymmdd(d) + ' ' + HHmmss(d)
}

window.next6Month = function(d) {
  d.setMonth(d.getMonth() + 6)
  return d
}

// Date.prototype.next6Month = function() {
//   this.setMonth(this.getMonth() + 6)
//   return this
// }


window.isSameDate = function(d1,d2) {
  return(
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
    )
}

function isValidDate(d) {
  return(d.toDateString() !== 'Invalid Date')
}

window.isSameMonth = function(date1,date2) {
  date1 = new Date(date1)
  date2 = new Date(date2)
  if(!isValidDate(date1) || !isValidDate(date2)){
    return false
  }
  return (date1.getFullYear() === date2.getFullYear())&&
    (date1.getMonth() === date2.getMonth())
}


window.toDateTimeString = function(d) {
  var date = d
  var comp, comps = [
  date.getUTCFullYear(),
  date.getUTCMonth() + 1,
  date.getUTCDate(),
  'T',
  date.getUTCHours(),
  date.getUTCMinutes(),
  date.getUTCSeconds(),
  'Z'
  ]
  for(var i = 0;i < comps.length; i++) {
    comp = comps[i]
    if(!/[TZ]/.test(comp) && comp < 10) {
      comps[i] = '0' + String(comp)
    }
  }
  return comps.join('')
}


window.DateTime = function(date, time) {
  var d = new Date(date)
  var t = new Date(time)
  d.setHours(t.getHours())
  d.setMinutes(t.getMinutes())
  d.setSeconds(t.getSeconds())
  return d
}

window.isBetween = function(d, startDate, endDate) {
  startDate = new Date(startDate)
  endDate = new Date(endDate)
  return(d.getTime() >= startDate.getTime()) && (d.getTime() <= endDate.getTime())
}


// Date.prototype.yyyymd = function() {
//   var yyyy = this.getFullYear().toString()
//   var m = (this.getMonth() + 1).toString()
//   var d = this.getDate().toString()
//   return yyyy + '-' + m + '-' + d
// }
// Date.prototype.mmdd = function() {
//   var mm = (this.getMonth() + 1).toString()
//   var dd = this.getDate().toString()
//   return(mm[1] ? mm : '0' + mm[0]) + '-' + (dd[1] ? dd : '0' + dd[0])
// }
// Date.prototype.HHmm = function() {
//   var HH = this.getHours().toString(),
//   mm = this.getMinutes().toString()
//   return(HH[1] ? HH : '0' + HH[0]) + ':' + (mm[1] ? mm : '0' + mm[0])
// }
// Date.prototype.mmddHHmm = function() {
//   return this.mmdd() + ' ' + this.HHmm()
// }



// const WEEKDAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
// Date.prototype.weekday = function() {
//   return WEEKDAY[this.getDay()]
// }
// Date.prototype.setHHmm = function(time) {
//   time = time.split(':')
//   this.setHours(parseInt(time[0]))
//   this.setMinutes(parseInt(time[1]))
//   return this
// }
// Date.prototype.setHHmmss = function(time) {
//   time = time.split(':')
//   this.setHours(parseInt(time[0]))
//   this.setMinutes(parseInt(time[1]))
//   this.setSeconds(parseInt(time[2]))
//   return this
// }
// Date.prototype.lastMonth = function() {
//   this.setMonth(this.getMonth() - 1)
//   return this
// }
// Date.prototype.last3Month = function() {
//   this.setMonth(this.getMonth() - 3)
//   return this
// }

// Date.prototype.next6Month = function() {
//   this.setMonth(this.getMonth() + 6)
//   return this
// }


// Date.prototype.nextMonth = function() {
//   this.setMonth(this.getMonth() + 1)
//   return this
// }

// Date.prototype.nextDay = function(num = 1) {
//   this.setDate(this.getDate() + num)
//   return this
// }

// Date.prototype.preDay = function(num = 1) {
//   this.setDate(this.getDate() - num)
//   return this
// }


// Date.prototype.equalTo = function(d) {
//   return this.getTime() === d.getTime()
// }
// Date.prototype.isValid = function(d) {
//   return(this.toDateString() !== 'Invalid Date')
// }


// Date.prototype.replaceTime = function(date) {
//   this.setHours(date.getHours())
//   this.setMinutes(date.getMinutes())
//   this.setSeconds(date.getSeconds())
//   return this
// }



// Date.today = function() {
//   var now = new Date()
//   return new Date(now.getFullYear(), now.getMonth(), now.getDate())
// }

// DateTime = function(date, time) {
//   var d = new Date(date)
//   var t = new Date(time)
//   d.setHours(t.getHours())
//   d.setMinutes(t.getMinutes())
//   d.setSeconds(t.getSeconds())
//   return d
// }

// Date.prototype.getWeekNumber = function() {
//   let d = new Date(this);
//   d.setHours(0,0,0);
//   d.setDate(d.getDate() + 4 - (d.getDay()||7));
//   var yearStart = new Date(d.getFullYear(),0,1);
//   var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
//   return [d.getFullYear(), weekNo];
// }

// Date.isSameMonth = function(date1,date2) {
//   date1 = new Date(date1)
//   date2 = new Date(date2)
//   if(!date1.isValid() || !date2.isValid()){
//     return false
//   }
//   return (date1.getFullYear() === date2.getFullYear())&&
//     (date1.getMonth() === date2.getMonth())
// }



// if(!String.prototype.includes) {
//   String.prototype.includes = function() {
//     'use strict'
//     return String.prototype.indexOf.apply(this, arguments) !== -1
//   }
// }





/** WEBPACK FOOTER **
 ** ./src/app/utils/polyfill.js
 **/